export default "/images/vendor/flag-icon-css/flags/4x3/ve.svg?b8bb0477d02228d82ffb54c74b24ec24";